import { render, staticRenderFns } from "./manageQuiz.vue?vue&type=template&id=525779fa&scoped=true&"
import script from "./manageQuiz.vue?vue&type=script&lang=js&"
export * from "./manageQuiz.vue?vue&type=script&lang=js&"
import style0 from "./manageQuiz.vue?vue&type=style&index=0&id=525779fa&lang=scss&scoped=true&"
import style1 from "./manageQuiz.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./manageQuiz.vue?vue&type=style&index=2&id=525779fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525779fa",
  null
  
)

export default component.exports